import React from 'react';
import { PseudoStates, PageTitle, useFetch } from '@cordata/buffet';
import { useParams } from 'react-router-dom';

import ReminderGroupsForm from '~/components/ReminderGroup/Form';

const ReminderGroupsDetails = () => {
  const { reminderGroupId } = useParams();
  const [status, data] = useFetch(`admin/notification-group/${reminderGroupId}`, { instance: 'p' });

  return status === 'success' ? (
    <>
      <PageTitle>{data.attributes.reminderGroupLabel}</PageTitle>

      <ReminderGroupsForm data={data} />
    </>
  ) : (
    <PseudoStates status={status} />
  );
};

export default ReminderGroupsDetails;
